const reducerServicosTypes = {
    BUSCAR_SERVICOS: "BUSCAR_SERVICOS",
    SET_SERVICOS: "SET_SERVICOS"
}

const reducerServicos = (state = { servicos: [], force: 0, reducerServicosTypes: reducerServicosTypes }, { type, payload }) => {
    
    let loading = false;

    switch (type) {
        case reducerServicosTypes.SET_SERVICOS:
            state.servicos.push(payload);
            return state;
            //return Object.assign({}, state, { servicos: payload }, { loading });
        case reducerServicosTypes.BUSCAR_SERVICOS:
            const force = state.force + 1;
            loading = true;
            return Object.assign({},{force},{loading});
        default:
            return state;
    }
}



//export default { reducerServicos, defaultStateServicos, reducerServicosTypes };
export default reducerServicos;